/* ///////////////////////////////// */
/* ///////////////////////////////// */
/* ///////////////////////////////// */

function Checkfor_Mobile_ProductImageZoom(media_id) { 
  //cl('{Checkfor_Mobile_ProductImageZoom}');
  var activeMedia = $(`.product-media-modal__content [data-media-id="${media_id}"]`)
  var add_zoom_function = false;
  var largest_image = activeMedia.attr('data-largest-image');
  var largest_image_size = activeMedia.attr('data-largest-size');
  var largest_image_height = activeMedia.attr('data-largest-height');
  if (largest_image != undefined && largest_image != '') {
    var add_zoom_function = true;
  }
  if (add_zoom_function == true) {
    /* only zoom when the largest image covers the whole viewport (width and height) */
    if (largest_image_height != undefined && ProductImageFillsViewport(largest_image_size, largest_image_height) == false) {
      var add_zoom_function = false;
      /* cl('ZOOM min size not reached'); */
    }
    if (add_zoom_function == true) {
      /* alert('apply zoom inside image box instead overlay'); */
      $('body.template-product').append('<div class="product-modal__zoom-wrapper"></div>');
      $('body.template-product .product-modal__zoom-wrapper').zoom({
        url: largest_image,
        callback: function(){
          /* this = the loaded zoom image; re-check against its real size */
          if (ProductImageFillsViewport(this.naturalWidth, this.naturalHeight) == false) {
            $('body.template-product .product-modal__zoom-wrapper').trigger('zoom.destroy').remove();
            return;
          }
          $('body.template-product .product-modal__zoom-wrapper').addClass('active');
          $('.product-media-modal').remove();
        }        
      });
    }
  }
}

/* ///////////////////////////////// */
/* ///////////////////////////////// */
/* ///////////////////////////////// */

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (!this.slider || !this.nextButton) return;
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="slide-"]');
    this.initPages();
  }
  update() {
    /* Temporarily prevents unneeded updates resulting from variant changes - This should be refactored as part of https://github.com/Shopify/dawn/issues/2057 */

    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
      $('.mobile-media-navigation__prev').addClass('disabled no-se');
    } else {
      this.prevButton.removeAttribute('disabled');
      $('.mobile-media-navigation__prev').removeClass('disabled no-se');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
      $('.mobile-media-navigation__next').addClass('disabled no-se');
    } else if ( this.currentPage == this.totalPages ) {
      this.nextButton.setAttribute('disabled', 'disabled');
      $('.mobile-media-navigation__next').addClass('disabled no-se');
    } else {
      this.nextButton.removeAttribute('disabled');
      $('.mobile-media-navigation__next').removeClass('disabled no-se');
    }
  }
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition,event.currentTarget);
  }

  setSlidePosition(position,step) {
    this.slider.scrollTo({
      left: position,
    });

    /* check has video */
    var slide_num = this.currentPage + 1;
    if ( $('.product__media-item.product__media-item-'+slide_num+' .deferred-media').length ) {
      var this_video_url = $('.product__media-item.product__media-item-'+slide_num+' template').attr('data-video-url');
      var this_media_html = '';
          this_media_html += '<div class="video-wrapper no-pe no-se">';
          this_media_html += '  <video width="100%" height="100%" playsinline inline loop autoplay muted>';
          this_media_html += '    <source src="'+this_video_url+'" type="video/mp4">';
          //this_media_html += '    <source src="movie.ogg" type="video/ogg">';
          this_media_html += '    Your browser does not support the video tag.';
          this_media_html += '  </video>';
          this_media_html += '</div>';
      $('.product__media-item.product__media-item-'+slide_num+'').html(this_media_html);
    }
  }
}
customElements.define('slider-component', SliderComponent);

/* ///////////////////////////////// */
/* mobile PDP: tap a slide -> full-screen vertical list of all images */
/* ///////////////////////////////// */

function InitPdpMobileViewer() {
  const viewer = document.querySelector('.pdp-mobile-viewer');
  if (!viewer || (window.Shopify && Shopify.designMode)) return;
  /* fixed positioning breaks under the transformed slider-component, so live under body */
  document.body.appendChild(viewer);
  const loader = document.querySelector('.pdp-mobile-viewer-loader');
  if (loader) document.body.appendChild(loader);

  const list = viewer.querySelector('.pdp-mobile-viewer__list');
  const images = Array.from(list.querySelectorAll('img[data-viewer-id]'));
  const closeButton = viewer.querySelector('.pdp-mobile-viewer__close');
  const slider = document.querySelector('.product__media-list');
  let currentId = null;
  let openedFrom = null;
  let pushedState = false;

  /* track the image being viewed, so closing lands the slider on it: first image still showing a real part below the sticky bar, or the last one at the end of the list */
  function updateCurrent() {
    const line = viewer.querySelector('.pdp-mobile-viewer__bar').offsetHeight + 40;
    const atEnd = viewer.scrollTop + viewer.clientHeight >= viewer.scrollHeight - 2;
    const current = atEnd ? images[images.length - 1] : (images.find((img) => img.getBoundingClientRect().bottom > line) || images[0]);
    currentId = current.dataset.viewerId;
  }
  let ticking = false;
  let openedAt = 0;
  viewer.addEventListener('scroll', () => {
    /* ignore the jump to the tapped image, which can end at the list bottom */
    if (ticking || performance.now() - openedAt < 200) return;
    ticking = true;
    requestAnimationFrame(() => { updateCurrent(); ticking = false; });
  });

  /* lazy images inside the hidden viewer never load on their own, so fetch them in the background once the page is done */
  function preloadImages() {
    images.forEach((img) => { img.loading = 'eager'; });
  }
  if (document.documentElement.clientWidth < 768) {
    if (document.readyState === 'complete') preloadImages();
    else window.addEventListener('load', preloadImages, { once: true });
  }

  /* resolves once every viewer image is loaded and decoded, or after the timeout so a slow/broken image can't block the viewer */
  function imagesReady(timeout) {
    preloadImages();
    const decoded = Promise.all(images.map((img) => img.decode().catch(() => {})));
    return Promise.race([decoded, new Promise((resolve) => setTimeout(resolve, timeout))]);
  }

  let pending = false;
  function open(id, trigger) {
    if (pending || !viewer.hidden) return;
    pending = true;
    if (loader) loader.classList.remove('inactive');
    imagesReady(4000).then(() => {
      pending = false;
      if (loader) loader.classList.add('inactive');
      show(id, trigger);
    });
  }

  function show(id, trigger) {
    const target = images.find((img) => img.dataset.viewerId === id) || images[0];
    openedFrom = trigger;
    currentId = target.dataset.viewerId;
    viewer.hidden = false;
    viewer.setAttribute('aria-hidden', 'false');
    disableBodyScroll();
    viewer.scrollTop = 0;
    openedAt = performance.now();
    /* scrollIntoView would include the list's fade-up transform and land 1.5rem off; the rect difference inside the list is transform-free */
    const targetTop = list.offsetTop + target.getBoundingClientRect().top - list.getBoundingClientRect().top;
    viewer.scrollTop = targetTop - (parseFloat(getComputedStyle(target).scrollMarginTop) || 0);
    /* force a style flush so the transition runs from the hidden state */
    clearTimeout(hideTimer);
    void viewer.offsetHeight;
    viewer.classList.add('is-open');
    closeButton.focus({ preventScroll: true });
    history.pushState({ pdpViewer: 1 }, '');
    pushedState = true;
  }

  let hideTimer = null;
  function close(fromPopstate) {
    if (!viewer.classList.contains('is-open')) return;
    viewer.classList.remove('is-open');
    viewer.setAttribute('aria-hidden', 'true');
    /* keep it rendered until the fade-out (0.35s in the snippet CSS) is done */
    hideTimer = setTimeout(() => { viewer.hidden = true; }, 350);
    enableBodyScroll();
    /* land the slider on the image the user was looking at */
    const slide = slider && slider.querySelector('[data-viewer-id="' + currentId + '"]');
    if (slide) slider.scrollTo({ left: slide.offsetLeft, behavior: 'instant' });
    if (openedFrom) openedFrom.focus({ preventScroll: true });
    if (pushedState && !fromPopstate) history.back();
    pushedState = false;
  }

  if (slider) {
    slider.addEventListener('click', (event) => {
      if (document.documentElement.clientWidth >= 768) return;
      const slide = event.target.closest('[data-viewer-id]');
      if (!slide) return;
      event.preventDefault();
      open(slide.dataset.viewerId, slide);
    });
  }
  closeButton.addEventListener('click', () => close(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(false); });
  window.addEventListener('popstate', () => close(true));
}
document.addEventListener('DOMContentLoaded', InitPdpMobileViewer);

/* ///////////////////////////////// */
/* ///////////////////////////////// */
/* ///////////////////////////////// */

class SlideshowComponent extends SliderComponent {

  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }
  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }
  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }
    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.setSlidePosition(this.slideScrollPosition);
    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }
  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }
  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }
  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }
  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }
  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }
  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }
  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }
  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }
  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }
  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;
    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;
    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;
    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];
    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';
    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;
    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';
    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);
    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
customElements.define('slideshow-component', SlideshowComponent);